import { createSelector } from 'reselect';

import { createApiSelectors } from 'utils/reduxUtils';

const getFormula = state => state.prescription.formula;

export const getScoring = createSelector(getFormula, state => {
  return state.data?.scoring;
});

const [, getPrescriptionError, getPrescriptionStatus] = createApiSelectors(
  state => state.prescription.formula
);

export { getPrescriptionError, getPrescriptionStatus };
